import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {
    HeadingLarge,
    HeadingSmall,
    Title,
} from "@khanacademy/wonder-blocks-typography";

import GutterDecorator from "../../gutter-decorator.tsx";

interface HeadingProps {
    headingType: keyof typeof headingTypes;
    elementProps: RenderElementProps;
    viewOnly?: boolean;
}

const HeadingNode: React.FC<HeadingProps> = ({headingType, elementProps}) => {
    const {attributes, element, children} = elementProps;
    const {Component, headingStyle, tag} = headingTypes[headingType];

    return (
        <Component {...attributes} style={headingStyle} tag={tag}>
            <GutterDecorator element={element}>{children}</GutterDecorator>
        </Component>
    );
};

const styles = StyleSheet.create({
    h1: {
        fontFamily: "'Source Serif Pro', 'Noto Serif', serif",
        fontSize: 32,
        fontWeight: 600,
        marginBlockEnd: spacing.medium_16,
        marginBlockStart: spacing.xSmall_8,
    },
    h2: {
        fontSize: 20,
        marginBlockStart: spacing.large_24,
        marginBlockEnd: spacing.medium_16,
    },
    h3: {
        fontSize: 18,
        marginBlockStart: spacing.large_24,
        marginBlockEnd: spacing.medium_16,
    },
});

const headingTypes = {
    "heading-one": {
        tag: "h1",
        headingStyle: styles.h1,
        Component: Title,
    },
    "heading-two": {
        tag: "h2",
        headingStyle: styles.h2,
        Component: HeadingLarge,
    },
    "heading-three": {
        tag: "h3",
        headingStyle: styles.h3,
        Component: HeadingSmall,
    },
};

export default HeadingNode;
